<template>
  <bar :chartdata="chartdata" :options="options"/>
</template>

<script>
import Bar from '@/components/charts/bar'

export default {
  name: 'ToolsFailedStacks',
  components: {
    Bar
  },
  props: {
    stacks: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Count'
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
    }
  },
  methods: {
    fillchartdata: function () {
      const dataset = []
      const labels = []

      for (const stack in this.stacks) {
        labels.push(stack)
        dataset.push(this.stacks[stack].length)
      }

      this.chartdata = {
        labels: labels,
        datasets: [{
          label: 'stacks',
          data: dataset,
          backgroundColor: '#118ab2'
        }]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ToolsFailedStacks.vue